import * as z from "zod/v4";

export const getNativeAccountsSettings = {
  name: "getNativeAccountsSettings" as const,
  input: z.null(),
  output: z.object({
    overrideAccountLinks: z.boolean(),
    redirectFromAccountsPages: z.boolean(),
  }),
};
